import React from "react";
import ShareButtons from "../../../../utility/ShareButtons";
import FAQAccordion from "../../../../utility/FAQAccordion";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
import { useGlobalData } from "../../../../contextApi/globalContextData";
import Slider from "react-slick";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesigntwo";
import ListDesign from "../../../../utility/serviceTemplateutility/ListDesigntwo";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
import { useCart } from "../../../../contextApi/cartContext";
export default function WeightLossInjections() {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();

  const { addToCart } = useCart();

  const product = {
    id: 1,
    title: "Weight loss injections in Dubai",
    price: 2499,
    description:
      "Doctor-prescribed injections for effective, non-surgical weight loss and diabetes management in Dubai.",
  };
  const faqs = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Which is the best weight loss injection?",
      answer:
        "Mounjaro (Tirzepatide), and Ozempic (Semaglutide) both are the best weight loss injections when used under medical supervision.",
    },
    {
      question: "How to lose weight in 7 days?",
      answer:
        "Focus on a calorie deficit, eat protein-rich meals, stay hydrated, exercise daily, and avoid processed foods for visible short-term weight loss. In addition, weight loss injections can help you achieve your goal faster.",
    },

    {
      question: "How can I lose 5kg in a week?",
      answer:
        "Losing 5kg in a week requires a strict diet, intense workouts, and hydration. Weight loss injections like Mounjaro, Ozempic, or Saxenda may help.",
    },
  ];

  const results = [
    {
      id: 1,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Before-After-Service-Images-1-2.jpg",
      alt: "weight loss treatment dubai",
    },
    {
      id: 2,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-1.jpg",
      alt: "weight loss dubai",
    },
    {
      id: 3,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-2.jpg",
      alt: "weight loss clinic in dubai",
    },
    {
      id: 4,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-3.jpg",
      alt: "weight loss injections",
    },
  ];

  // Basic slider settings without arrows
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false, // Disable arrows
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const weightLossBenefits = [
    { heading: " Key Benefits of Weight Loss Treatment in Dubai" },
    {
      icon: "fa-solid fa-syringe", // Injection / Non-surgical
      title: "Non-Surgical & Minimally Invasive",
      description:
        "Experience safe and effective results without the need for surgery or long recovery periods.",
    },
    {
      icon: "fa-solid fa-flask-vial", // Scientific method
      title: "Scientifically Proven Methods",
      description:
        "Benefit from treatments backed by research, ensuring reliable results and peace of mind.",
    },
    {
      icon: "fa-solid fa-bullseye", // Targeted
      title: "Targeted Fat Reduction",
      description:
        "Focus on stubborn areas that resist diet and exercise, achieving a more sculpted shape.",
    },
    {
      icon: "fa-solid fa-sliders", // Personalized/custom plan
      title: "Personalized Treatment Plans",
      description:
        "Receive bespoke solutions designed around your body’s unique needs and goals.",
    },
    {
      icon: "fa-solid fa-user-doctor",
      title: "Skilled Medical Professionals",
      description:
        "Enjoy expert guidance and care from certified practitioners specializing in weight management.",
    },
    {
      icon: "fa-solid fa-face-smile-beam",
      title: "Enhanced Confidence & Wellbeing",
      description:
        "Achieve your ideal physique, boosting self-esteem and encouraging a healthier lifestyle.",
    },
  ];

  const weightLossprocedureSteps = [
    { heading: "Easy 4 Steps for Weight Loss Procedure" },
    {
      icon: "fa-solid fa-user-doctor", // Consultation
      title: "Consultation",
      description:
        "During your initial consultation, our expert evaluates your health assessment, including a Body Composition Analysis (BCA) and blood tests to determine your suitability for the weight loss program.",
      link: "https://elitebodyhome.com/blood-test-at-home-dubai/",
    },
    {
      icon: "fa-solid fa-vial-circle-check", // Preparation
      title: "Preparation",
      description:
        "The targeted areas are cleansed, and the patient is prepared for the injection procedure. No extensive pre-treatment steps are required.",
    },
    {
      icon: "fa-solid fa-syringe", // Injection
      title: "Injection Procedure",
      description:
        "The selected injections like Mounjaro or Ozempic are administered to the targeted areas of the body.",
    },
    {
      icon: "fa-solid fa-calendar-check", // Follow-up
      title: "Follow-Up Appointments",
      description:
        "Follow-up visits ensure you're progressing towards your goals, with adjustments to your treatment plan as needed.",
    },
  ];

  const injections = [
    {
      name: "Mounjaro Injection",
      doses: "2.5mg, 5mg, 7.5mg, 10mg, 12.5mg, and 15mg",
      link: "https://elitebodyhome.com/services/mounjaro-injection/",
      description:
        "Also known as tirzepatide, is FDA-approved prescription injection primarily used to treat adults with type 2 diabetes. It targets specific hormonal pathways to help regulate blood sugar levels and control appetite. When combined with a balanced diet and regular exercise, Mounjaro Injection supports effective, long-term weight management and improved metabolic health.",
    },
    {
      name: "Ozempic Injection",
      doses: "0.5mg, 1mg, 2mg",
      link: "https://elitebodyhome.com/services/ozempic-injection/",
      description:
        "Also known as semaglutide, it helps improve glycemic control and supports weight management when combined with a balanced diet and regular exercise. This treatment offers a convenient, effective approach to maintaining healthier blood sugar levels and overall metabolic health.",
    },
  ];

  return (
    <>
      <title>
        Weight Loss Injections in Dubai â€“ Safe &amp; Effective Weight Loss
        Solutions
      </title>
      <meta
        name="description"
        content="Achieve your weight loss goals with expert weight loss Injections in Dubai. Elite Body Home Polyclinic, a leading weight loss clinic in Dubai UAE. Our experienced medical professionals offer personalized solutions to support your weight management journey. Book a free consultation today!"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/weight-loss-injections/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Weight Loss Injections in Dubai â€“ Safe &amp; Effective Weight Loss Solutions"
      />
      <meta
        property="og:description"
        content="Achieve your weight loss goals with expert weight loss Injections in Dubai. Elite Body Home Polyclinic, a leading weight loss clinic in Dubai UAE. Our experienced medical professionals offer personalized solutions to support your weight management journey. Book a free consultation today!"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/weight-loss-injections/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-15T15:54:25+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-feature.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-feature.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Weight Loss Injections in Dubai" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta
        property="og:video"
        content="https://www.youtube.com/embed/4E0Qa92FLpM"
      />
      <meta property="video:duration" content="28" />
      <meta property="ya:ovs:upload_date" content="2024-09-20T09:28:28-07:00" />
      <meta property="ya:ovs:allow_embed" content="true" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Weight Loss Injections in Dubai â€“ Safe &amp; Effective Weight Loss Solutions"
      />
      <meta
        name="twitter:description"
        content="Achieve your weight loss goals with expert weight loss Injections in Dubai. Elite Body Home Polyclinic, a leading weight loss clinic in Dubai UAE. Our experienced medical professionals offer personalized solutions to support your weight management journey. Book a free consultation today!"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-feature.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div className="">
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{ border: "2px solid #c69933" }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-large.png"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Aqualyx fat dissolving injections in Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    <div
                      className="p-4 p-md-5 w-100"
                      style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                      <h1
                        className="display-5 fw-bold mb-3"
                        style={{
                          color: "#c69933",
                        }}
                      >
                        Weight Loss Injections in Dubai
                      </h1>
                      <p className="fs-5 text-secondary mb-4">
                        <ul>
                          <li>Non-Surgical Fat Reduction Solutions</li>
                          <li>Personalized Diet Plan</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Weight Loss Injection in Dubai
                </li>
              </ol>
            </nav>
            <QuickNavigation />
            <div>
              <p style={{ textAlign: "left" }}>
                Elite Body Home Polyclinic, a leading weight loss clinic in
                Dubai Jumeirah, offers non-surgical, scientifically backed
                treatments to help you achieve your ideal body shape. Our
                targeted weight loss injections effectively tackle resistant
                areas without invasive procedures, ensuring a safe, comfortable
                journey to a slimmer you. Administered by experienced
                professionals, each treatment is personalized to boost your
                confidence and fit seamlessly into your lifestyle. Begin your
                transformation at Dubai’s premier{" "}
                <a
                  href="https://elitebodyhome.com/"
                  target="_blank"
                  rel="noopener"
                >
                  aesthetic clinic
                </a>
                .
              </p>
            </div>
            <section id="types" className="py-">
              <div className="container">
                <div className="text-center mb-4">
                  <h2 className="title">
                    Effective Weight Loss Injections Offered by Elite Body Home
                  </h2>
                  <p className="mt-3">
                    We provide several types of weight loss injections in Dubai
                    that cater to individual needs and goals:
                  </p>
                </div>

                <div className="text-center mb-5">
                  <img
                    src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-banner-large.jpg"
                    alt="Weight Loss Banner"
                    className="img-fluid rounded shadow w-50 h-auto"
                  />
                </div>

                <div className="mb-5">
                  <h3>Mounjaro Injection:</h3>
                  <p>
                    <strong>
                      (Available in doses of 2.5mg, 5mg, 7.5mg, 10mg, 12.5mg,
                      and 15mg)
                    </strong>
                  </p>
                  <p>
                    <a
                      href="https://elitebodyhome.com/services/mounjaro-injection/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline text-primary"
                    >
                      Mounjaro Injection
                    </a>
                    , also known as <strong>tirzepatide</strong>, is
                    FDA-approved prescription injection primarily used to treat
                    adults with type 2 diabetes. It targets specific hormonal
                    pathways to help regulate blood sugar levels and control
                    appetite. When combined with a balanced diet and regular
                    exercise, Mounjaro Injection supports effective, long-term
                    weight management and improved metabolic health.
                  </p>
                </div>

                <div>
                  <h3>Ozempic Injection:</h3>
                  <p>
                    <strong>(Available in doses of 0.5mg, 1mg, 2mg)</strong>
                  </p>
                  <p>
                    <a
                      href="https://elitebodyhome.com/services/ozempic-injection/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline text-primary"
                    >
                      Ozempic Injection
                    </a>
                    , also known as semaglutide, helps improve glycemic control
                    and supports weight management when combined with a balanced
                    diet and regular exercise. This treatment offers a
                    convenient, effective approach to maintaining healthier
                    blood sugar levels and overall metabolic health.
                  </p>
                </div>
              </div>
            </section>
            <div id="procedures">
              <ListDesign listitems={weightLossprocedureSteps} />
            </div>
            <div id="benefits">
              <CardDesign carditems={weightLossBenefits} />
            </div>
            <div>
              <div>
                <h2 className="title">Cost of Weight Loss Injections Dubai</h2>
              </div>
              <div>
                <p>
                  The cost of Weight Loss Injection can vary depending on the
                  clinic and the specific treatment plan. Typically, the price
                  ranges from <strong>AED 1,999 to AED 3,999</strong> per
                  session in Dubai.{" "}
                </p>
                <p>
                  At Elite Body Home, offers a customized weight loss package at
                  an affordable price that includes-{" "}
                </p>
                <ul>
                  <li>4 Weight loss injection</li>
                  <li>2 EMS sessions + 2 water retention treatment</li>
                  <li>Dietitian follow up</li>
                  <li>Fitness assessment</li>
                  <li>Vital check-up</li>
                </ul>
                <p>
                  <strong>
                    <em>
                      We recommend booking a FREE consultation to receive
                      detailed pricing tailored to your treatment plan.
                    </em>
                  </strong>
                </p>
              </div>
            </div>
            <section id="eligibility" className="py-5">
              <div className="container">
                <h2 className="title mb-4">
                  Who Is Eligible for Weight Loss Programs?
                </h2>
                <div className="row align-items-center">
                  {/* Image */}
                  <div className="col-md-6 mb-4 mb-md-0">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-large.png"
                      alt="weight loss injections dubai"
                      className="img-fluid rounded shadow"
                    />
                  </div>

                  {/* Text Content */}
                  <div className="col-md-6">
                    <p>
                      Individuals looking to lose excess weight, improve overall
                      health, or address obesity and related conditions can
                      benefit from this injection. Typically, adults with a BMI
                      indicating overweight or obesity are prime candidates.
                      However, eligibility also depends on personal health,
                      medical history, and lifestyle factors.
                    </p>
                    <p>
                      It’s recommended to consult our professionals for an
                      assessment and personalized recommendations. We offer a{" "}
                      <strong>FREE consultation</strong> to help you determine
                      the best approach to achieving your weight loss goals.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <div className="container my-5" id="results">
              <h2 className="title mb-4">Before & After Results</h2>

              <div className="px-2">
                <Slider {...settings}>
                  {results.map((result) => (
                    <div key={result.id} className="px-2">
                      <img
                        src={result.src}
                        alt={result.alt}
                        className="img-fluid rounded"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

            <div className="container my-4">
              <div
                className="card border-0 shadow-sm rounded-3 overflow-hidden"
                style={{ maxWidth: "380px", margin: "auto" }}
                itemScope
              >
                {/* Optimized Image */}
                <img
                  src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-large.png"
                  alt="Mounjaro Injection in Dubai"
                  className="card-img-top"
                  style={{ height: "220px", objectFit: "cover" }}
                  itemProp="image"
                  loading="lazy"
                />

                <div className="card-body px-3 py-3 text-center">
                  {/* Product Title */}
                  <h2
                    className="h5 fw-bold mb-2 text-dark"
                    itemProp="name"
                    style={{ lineHeight: "1.3" }}
                  >
                    Weight loss injections in Dubai
                  </h2>

                  {/* Compact Description */}
                  <p
                    className="text-muted small mb-3"
                    itemProp="description"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Doctor-prescribed injections for effective, non-surgical
                    weight loss and diabetes management in Dubai.
                  </p>

                  {/* Price Section */}
                  <div className="mb-3" itemProp="offers" itemScope>
                    <span
                      className="text-success fw-bold"
                      style={{ fontSize: "1.05rem" }}
                    >
                      {/* <span itemProp="price">AED 2499</span> */}
                      <meta itemProp="priceCurrency" content="AED" />
                    </span>
                  </div>

                  {/* CTA Button */}
                  <button
                    className="btn rounded-pill px-3 py-1 text-white"
                    style={{
                      backgroundColor: "#c69933",
                      border: "2px solid #c69933",
                      fontSize: "0.9rem",
                    }}
                    onClick={() => addToCart(product)}
                    aria-label="Book weightloss Injections"
                  >
                    Add to Cart
                  </button>
                </div>

                {/* Hidden SEO Data */}
                <meta itemProp="brand" content="Elite Body Home" />
                <meta itemProp="sku" content="AQX-001" />
              </div>
            </div>

            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials data={sectionsData["Success Stories"]} />
            <WhyUs language="en" />
            <FAQAccordion faqData={faqs} />
            <ShareButtons url={serviceUrl} />
          </div>

          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
